/**
 * vue-sparklines v2.0.1
 * (c) 2022 tangzhen@me.com
 * @license MIT
 */

var genColor = (function () {
  var characters = "0123456789ABCDEF";
  var color = "#";
  var i = 0;

  for (; i < 6; i++) {
    color += characters[Math.floor(Math.random() * 16)];
  }

  return color;
});

export { genColor as default };
//# sourceMappingURL=genColor.js.map
